import {
  __decorateClass
} from "./chunk.Y3TZ4FJV.js";

// src/assets/scripts/mixins/withBadge.ts
import { property } from "lit/decorators.js";
function WithBadge(baseClass) {
  class WithBadgeMixin extends baseClass {
    constructor() {
      super(...arguments);
      this._hasBadge = false;
    }
    connectedCallback() {
      super.connectedCallback();
      if (this.badge && !this._hasBadge) {
        this._addBadge();
      }
    }
    update(changedProperties) {
      super.update(changedProperties);
      if (changedProperties.has("badge")) {
        if (this.badge && !this._hasBadge) {
          this._addBadge();
        }
        if (this.badge) {
          this._badgeElement.innerHTML = this.badge.count ? this.badge.count + "" : "";
          this.parentElement.style.setProperty("--badgeColor", this._getBadgeColor());
        }
        if (!this.badge && this._hasBadge) {
          this.parentElement.style.setProperty("--badgeColor", this._getBadgeColor());
          this._removeBadge();
        }
      }
    }
    _addBadge() {
      this._hasBadge = true;
      this._badgeElement = document.createElement("span");
      this._badgeElement.classList.add(
        "absolute",
        `right-[${this.badge.small ? "-4px" : "-10px"}]`,
        `top-[${this.badge.small ? "-4px" : "-10px"}]`,
        `h-[${this.badge.small ? "10px" : "16px"}]`,
        `min-w-[${this.badge.small ? "10px" : "16px"}]`,
        "rounded-full",
        "px-[4px]",
        "py-[2px]",
        "text-center",
        "text-[11px]",
        "text-p-mini",
        "font-medium",
        "leading-[12px]",
        "z-[2]"
      );
      this.parentElement.style.setProperty("--badgeColor", this._getBadgeColor());
      this._badgeElement.style.transition = "background-color 0.2s ease-in-out";
      this._badgeElement.style.backgroundColor = "var(--badgeColor)";
      this._badgeElement.innerText = this.badge?.count ? this.badge.count + "" : "";
      this.shadowRoot.appendChild(this._badgeElement);
      this.style.position = "relative";
    }
    /**
     * Method to return a tailwind class for a color by name. If a hex code is provided, it is returned as is. If no color is provided, the default color '#ccc' is returned.
     */
    _getBadgeColor() {
      switch (this.badge?.color) {
        case "warning":
          return "#cc8a00";
        case "error":
          return "#971b2f";
        case "ok":
          return "#008675";
        case "unknown":
          return "#ccc";
        default:
          return this.badge?.color ? `${this.badge?.color}` : "initial";
      }
    }
    _removeBadge() {
      this._hasBadge = false;
      this.shadowRoot.removeChild(this._badgeElement);
    }
  }
  __decorateClass([
    property({ type: Object })
  ], WithBadgeMixin.prototype, "badge", 2);
  return WithBadgeMixin;
}

export {
  WithBadge
};
